"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Divider = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Divider = _styledComponents["default"].hr.withConfig({
  displayName: "Dividerstyle__Divider",
  componentId: "sc-1641sdx-0"
})(function (_ref) {
  var color = _ref.theme.color;
  return {
    backgroundColor: color.line.medium,
    border: 'none',
    height: 1,
    margin: 0,
    flexShrink: 0,
    width: '100%'
  };
});

exports.Divider = Divider;